import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';

export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function () {
      const title = this.htmlTitle; // PDF 标题

      html2Canvas(document.querySelector('#pdfDom'), {
        allowTaint: true,
        useCORS: true, // 确保跨域资源加载
        y: 72, // 对 Y 轴进行裁切
        dpi: window.devicePixelRatio, // 降低 DPI
        scale: 1, // 降低渲染比例
      })
        .then(function (canvas) {
          const contentWidth = canvas.width;
          const contentHeight = canvas.height;
          const pageHeight = 841.89; // A4 页面高度
          let leftHeight = contentHeight;
          let position = 0;
          const imgWidth = 595.28; // A4 页面宽度
          const imgHeight = (imgWidth / contentWidth) * contentHeight; // 按比例计算高度

          // 检查尺寸是否有效
          if (!imgWidth || !imgHeight) {
            console.error('无效的图像尺寸');
            return;
          }

          // 转换 canvas 为图片
          const pageData = canvas.toDataURL('image/jpeg', 1.0);
          const PDF = new JsPDF('p', 'pt', 'a4');

          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= pageHeight;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }

          // 保存 PDF 文件
          PDF.save(`${title}.pdf`);
        })
        .catch(function (error) {
          console.error('生成 PDF 时出错:', error);
        });
    };
  },
};
